import React from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import OWAncillaryExceptionContent from "./OWAncillaryExceptionContent";
import {Box} from "@mui/material";

const OWAncillaryExceptionContainer = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Box>
            <SectionHeader title={t("translation:auths.SCOPE_PRC_VIEW_OW_ANCILLARY_EXCEPTION.name")}/>
            <OWAncillaryExceptionContent readOnly={false}/>
        </Box>
    );
};

export default OWAncillaryExceptionContainer;